import { Stack, StackProps } from "@mui/material";
import { EventStatus } from "graphql/generated/types";
import { mergeSx, Sx } from "utils/sx";

export type EventCardMainSectionProps = {
    children: React.ReactNode;
    status?: EventStatus
} & StackProps

const styles: Sx = theme => ({
    backgroundColor: "var(--background-color)",
    borderRadius: theme.spacing(0.5, 0.5, 0, 0),
});

const liveStyles: Sx = {
    backgroundColor: "var(--background-color-live)",
};

export const EventCardMainSection: React.FC<EventCardMainSectionProps> = ({ children, status, sx, ...props }) => {
    return (
        <Stack
            spacing={1.5}
            direction="column"
            padding={2}
            sx={mergeSx(styles, status === "on" && liveStyles, sx)}
            data-testid="event-card-main-section"
            {...props}
        >
            {children}
        </Stack>
    );
}; 
